import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import store from "@/store";

const LOGIN_PATH = "/user/login";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  document.title = `${String(to.meta.title || "qOJ")} - qOJ`;

  const requiresAuth = Boolean(to.meta.requiresAuth);
  const requiresAdmin = Boolean(to.meta.requiresAdmin);
  const publicOnly = Boolean(to.meta.publicOnly);
  const loginUser = store.state.user.loginUser;
  const isWxLoginCallback =
    to.path === LOGIN_PATH && typeof to.query.wxLogin === "string";

  const shouldBlockForLoginState = requiresAuth || requiresAdmin || publicOnly;

  if (!loginUser?.id && shouldBlockForLoginState) {
    await store.dispatch("user/fetchLoginUser");
  } else if (!loginUser?.id) {
    store.dispatch("user/fetchLoginUser").catch(() => undefined);
  }

  const isLogin = Boolean(store.state.user.loginUser?.id);

  if (requiresAuth && !isLogin) {
    return {
      path: "/user/login",
      query: { redirect: to.fullPath },
    };
  }

  if (requiresAdmin && store.state.user.loginUser?.userRole !== "admin") {
    return "/403";
  }

  if (publicOnly && isLogin && !isWxLoginCallback) {
    return "/";
  }

  return true;
});

export default router;
